import { useState, useEffect } from 'react'
import { getSingle, save, update } from '../../../modules/appointment'

const useOperations = (appointmentId) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)

  const handleSave = async data => {
    setLoading(true)
    const id = save(data)
    setLoading(false)
    handleFetch(id)
    return id
  }

  const handleUpdate = async (id, data) => {
    setLoading(true)
    await update(id, data)
    setLoading(false)
    handleFetch(id)
    return id
  }

  const handleFetch = async (id) => {
    setLoading(true)
    const data = await getSingle(id || appointmentId)
    setData(data)
    setLoading(false)
  }

  useEffect(() => {
    handleFetch()
  }, [appointmentId])

  return {
    handleSave,
    loading,
    handleUpdate,
    handleFetch,
    data
  }
}

export default useOperations
